import styled from 'styled-components';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLinkContainer = styled.div.withConfig({
  displayName: "ToolLink__StyledLinkContainer",
  componentId: "sc-1fyrb05-0"
})(["padding-bottom:4px;"]);
const StyledUILink = styled(UILink).withConfig({
  displayName: "ToolLink__StyledUILink",
  componentId: "sc-1fyrb05-1"
})(["font-weight:500;margin-bottom:;"]);
function CopyButton({
  text
}) {
  return /*#__PURE__*/_jsx(UICopyButton, {
    use: "link",
    value: text,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "duplicate",
      size: 16
    })
  });
}
function ToolLink({
  isCopyable = false,
  label = '',
  onClick = () => {},
  text,
  url
}) {
  return /*#__PURE__*/_jsxs(StyledLinkContainer, {
    className: "tool-link",
    children: [label ? /*#__PURE__*/_jsxs(View, {
      "data-test-id": "label",
      marginInlineEnd: "100",
      as: "span",
      children: [label, ":"]
    }) : null, /*#__PURE__*/_jsx(StyledUILink, {
      "data-test-id": "link",
      external: true,
      href: url,
      onClick: onClick,
      children: text
    }), isCopyable ? /*#__PURE__*/_jsx(CopyButton, {
      text: text
    }) : null]
  });
}
export default ToolLink;